/**
 * Thin axios wrappers around /api/billing/v2/credits.
 *
 * Note the unit: everything here is USD as a number, never cents. The meter
 * prices calls to eight decimals because the common one costs about $0.008,
 * and rounding that to a cent either bills nothing or overcharges by a
 * quarter — so the UI formats on the way out and never rounds on the way in.
 */
import axiosInstance from 'shared/services/api/axiosInstance';

export async function getCredits(teamId) {
  const { data } = await axiosInstance.get('/billing/v2/credits', { params: { teamId } });
  return data;
}

export async function getCreditRuns(teamId, limit = 25) {
  const { data } = await axiosInstance.get('/billing/v2/credits/runs', { params: { teamId, limit } });
  return data?.runs || [];
}

export async function getRunCalls(teamId, runId) {
  const { data } = await axiosInstance.get(
    `/billing/v2/credits/runs/${encodeURIComponent(runId)}`, { params: { teamId } },
  );
  return data?.calls || [];
}

export async function startCreditCheckout(teamId, amountUsd) {
  const { data } = await axiosInstance.post('/billing/v2/credits/checkout', { teamId, amountUsd });
  return data;
}
